import Moment from "moment";
import Im from "immutable";

export const dateToText = (date, offsetDays = -1) => {
  if (!date) return null;
  return `${Moment(date).add(offsetDays, "days").format("Do MMM YY")}`;
};

export const getLatestValue = (values) => {
  if (!values) {
    return null;
  }
  let latestTime = null;
  let latestValue = null;

  for (let [valueId, value] of values) {
    if (!latestTime) {
      latestValue = value;
      latestTime = new Date(value.get("created"));
    } else if (new Date(value.get("created")) >= latestTime) {
      latestValue = value;
      latestTime = new Date(value.get("created"));
    }
  }
  return latestValue;
};

export const pathHasInputs = (path, inputsByPath) => {
  return ((inputsByPath || Im.Map()).get(path) || Im.List()).filter((i) => i != undefined).size > 0;
};

const getKeySet = (o) => {
  return Im.Set(Im.isImmutable(o) ? o.keys() : Object.keys(o));
};

const getValue = (o, key) => {
  return Im.isImmutable(o) ? o.get(key) : o[key];
};

/* Get the diff between Javascript objects i and j - but the values may be immutable
 */
export const hasDiff = (i, j, logPrefix = "") => {
  // Check if the props keys have changed
  let iKeys = getKeySet(i);
  let jKeys = getKeySet(j);

  const logger = logPrefix ? console.log : () => {};

  if (!iKeys.equals(jKeys)) {
    logger(`${logPrefix}:Keys have changed`, iKeys.toJS(), jKeys.toJS());
    return true;
  }

  // Check if immutable structures in the props have changed
  for (let key of iKeys) {
    let _i = getValue(i, key);
    let _j = getValue(j, key);
    if (Im.isImmutable(_i)) {
      if (_i && !_i.equals(_j)) {
        logger(`${logPrefix}:Immutable value has changed`, key, _i.toJS(), Im.isImmutable(_j) ? _j.toJS() : _j);
        return true;
      }
    } else {
      if (_i !== _j) {
        logger(`${logPrefix}:Plain JS value has changed`, key, _i, _j);
        return true;
      }
    }
  }

  return false;
};
